var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 0C13.4311 0 0 13.4317 0 29.9995C0 46.5682 13.4311 60 30 60C46.5677 60 60 46.5685 60 29.9995C60 13.4317 46.5677 0 30 0ZM30.3505 47.546C20.6807 47.546 12.8486 39.694 12.8486 29.9998C12.8486 20.3058 20.6807 12.4538 30.3505 12.4538C35.0762 12.4538 39.0243 14.1973 42.055 17.0268L37.1208 21.9727V21.9615C35.2835 20.2068 32.9538 19.3078 30.3505 19.3078C24.575 19.3078 19.8824 24.1986 19.8824 29.9893C19.8824 35.7785 24.5751 40.6812 30.3505 40.6812C35.5902 40.6812 39.1558 37.6765 39.8895 33.5532H30.3505V26.71H46.8125C47.0315 27.883 47.1513 29.1115 47.1513 30.3945C47.1513 40.418 40.4577 47.546 30.3505 47.546Z",
    fill: "#9C5435"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.8a1c00f9b3c707ded8af3c07a94571a7.svg";
export { ForwardRef as ReactComponent };